import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { pagesService, sitePagesService } from './pagesService'
import { PagesServiceSideEffects } from './pagesServiceSideEffects'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(sitePagesService)
}

export const page: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(pagesService)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	page(bind)
}

export const editor: ContainerModuleLoader = (bind) => {
	bind(ModelUpdatesHandlersImplementor).to(PagesServiceSideEffects)
}
